import { useBackend } from "../../services";

export const useGetStoreProducts = () => {
  const { get } = useBackend();
  const getStoreProducts = () => get("products/stores");
  return { getStoreProducts };
};
